module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-void"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Emit Credit note")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Credit note for the invoice:  "), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns"
  }, [_c('label', [_vm._v("Invoice credit description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voidFields.reason),
      expression: "voidFields.reason"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.voidFields.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.voidFields, "reason", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "medium-12 columns"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voidFields.refundOnGateway),
      expression: "voidFields.refundOnGateway"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.invoice.status !== 'PAID'
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.voidFields.refundOnGateway, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.voidFields, "refundOnGateway", true)
      }
    }
  }), _vm._v("Refund on gateway  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voidFields.refundOnGateway),
      expression: "voidFields.refundOnGateway"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.voidFields.refundOnGateway, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.voidFields, "refundOnGateway", false)
      }
    }
  }), _vm._v("Refund on wallet")]), _c('div', {
    staticClass: "manual"
  }, [_c('table', [_c('thead', [_c('tr', _vm._l((['ID', 'Walletable', 'Vat', 'Subtotal', 'Total', 'Amount']), function(head) {
    return _c('th', [_vm._v(_vm._s(head))])
  }), 0)]), _c('tbody', _vm._l((_vm.invoice.records), function(record) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(record.id))]), _c('td', [_c('div', {
      staticClass: "walletable"
    }, [_vm._v(_vm._s(record.walletable_type.replace(/App\\Models\\/, '')) + " " + _vm._s(record.walletable_id))]), _vm._l((record.reason.split('|')), function(reason) {
      return (record.walletable_type.replace(/App\\Models\\/, '') != 'Reservation') ? _c('div', {
        staticClass: "reason"
      }, [_vm._v(_vm._s(reason))]) : _vm._e()
    })], 2), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency((record.amount * -record.tax).toFixed(2))))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency((record.amount))))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(((record.amount) + (record.amount * -record.tax)).toFixed(2))))]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.voidFields.records[record.id]),
        expression: "voidFields.records[record.id]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.voidFields.records[record.id]) ? _vm._i(_vm.voidFields.records[record.id], null) > -1 : (_vm.voidFields.records[record.id])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.voidFields.records[record.id],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.voidFields.records, record.id, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.voidFields.records, record.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.voidFields.records, record.id, $$c)
          }
        }
      }
    }), _c('label', [_vm._v("Correct amount")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.voidFields.records[record.id]),
        expression: "voidFields.records[record.id]"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "disabled": _vm.voidFields.records[record.id] === false
      },
      domProps: {
        "value": (_vm.voidFields.records[record.id])
      },
      on: {
        "keyDown": _vm.isNumber,
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.voidFields.records, record.id, $event.target.value)
        }, function($event) {
          return _vm.checkValue(record)
        }]
      }
    }), _c('div', {
      staticClass: "help-text"
    }, [_vm._v("Insert above the real amount you want to charge (VAT included). Leave it empty for a full refund."), _c('br'), _vm._v("E.g. if you want to give the customer a 60% discount on a cost of 100 €, enter 40 €")])])])
  }), 0)])]), _c('h2', {
    staticClass: "text-right"
  }, [_vm._v("Invoice total " + _vm._s(_vm.$priceWithcurrency(_vm.invoice.total)))]), _c('h2', {
    staticClass: "text-right"
  }, [_vm._v("Amount " + _vm._s(_vm.$priceWithcurrency(_vm.recordsAmount)))])])]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "disabled": _vm.voidFields.reason === '' || _vm.recordsAmount == 0,
      "color-class": "success",
      "action": _vm.voidInvoice
    },
    slot: "footer"
  }, [_vm._v("Create")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5442f7e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/InvoiceRevealVoid.vue
// module id = 2504
// module chunks = 1